import { DeviceType, DeviceTypeRepository } from '@telespot/domain';

export interface ListDeviceTypesInput {
  searchTerm?: string;
  limit?: number;
  lastItemName?: string;
}

export interface ListDeviceTypesOutput {
  id: string;
  name: string;
  version: string;
}

export interface IListDeviceTypesQuery {
  /**
   * Lists device types ordered by name, paginated by `lastItemName` cursor and
   * narrowed by the optional search term. Repository errors propagate so the
   * caller's pagination effect can surface them.
   */
  execute(input: ListDeviceTypesInput): Promise<ListDeviceTypesOutput[]>;
}

export class ListDeviceTypesQuery implements IListDeviceTypesQuery {
  constructor(private readonly deviceTypeRepository: DeviceTypeRepository) {}

  public async execute(input: ListDeviceTypesInput): Promise<ListDeviceTypesOutput[]> {
    const deviceTypes = await this.deviceTypeRepository.getAll(input.searchTerm, input.limit, input.lastItemName);
    return deviceTypes.map((deviceType: DeviceType) => ({
      id: deviceType.id,
      name: deviceType.name,
      version: deviceType.version,
    }));
  }
}
